function coerceDataValue(value) {
    if (value === 'true') {
        return true;
    }

    if (value === 'false') {
        return false;
    }

    if (value.trim() !== '' && !Number.isNaN(Number(value))) {
        return Number(value);
    }

    if ((value.startsWith('{') && value.endsWith('}')) || (value.startsWith('[') && value.endsWith(']'))) {
        try {
            return JSON.parse(value);
        } catch (error) {
            return value;
        }
    }

    return value;
}

function formatDataLayerKey(attributeName) {
    return attributeName
        .replace(/^dl/, '')
        .replace(/^[A-Z]/, letter => letter.toLowerCase());
}

function buildDataLayerPayload(element) {
    const { dlEvent, ...dataAttributes } = element.dataset;

    if (!dlEvent) {
        return null;
    }

    const payload = {
        event: dlEvent,
    };

    Object.entries(dataAttributes).forEach(([key, value]) => {
        if (!key.startsWith('dl')) {
            return;
        }

        payload[formatDataLayerKey(key)] = coerceDataValue(value);
    });

    if (!payload.linkText) {
        payload.linkText = element.textContent.trim();
    }

    if (!payload.linkUrl && element.href) {
        payload.linkUrl = element.href;
    }

    return payload;
}

document.addEventListener('click', event => {
    const trigger = event.target.closest('.js-datalayer-push');

    if (!trigger) {
        return;
    }

    const payload = buildDataLayerPayload(trigger);

    if (!payload) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
});
